import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { AppButton } from 'src/component/common/analog/molecule/button/AppButton'
import { ModalWindow } from 'src/component/common/analog/template/ModalWindow'
import { CircularProgress, Typography } from '@mui/material'
import { Palette } from 'src/feature/theme/model/Palette'

export type ProjectNotificationPromptProps = {
  open: boolean
  onClose: () => void
  onConfirm: (notifyUsers: boolean) => Promise<void>
  isSubmitting: boolean
  description: string
  yesText: string
  noText: string
}

export function ProjectNotificationPrompt({
  open,
  onClose,
  onConfirm,
  isSubmitting,
  description,
  yesText,
  noText,
}: ProjectNotificationPromptProps) {
  return (
    <ModalWindow
      modalProps={{
        open,
        onClose,
        PaperProps: {
          sx: {
            maxWidth: { xs: '90%', md: '60%', lg: '35%' },
            borderRadius: '20px',
            backgroundColor: Palette.WHITE,
          },
        },
      }}
    >
      <AppBox sx={styles.container}>
        <Typography sx={styles.description}>
          {description}
        </Typography>
        <AppBox sx={styles.buttons}>
          <AppButton
            variant="outlined"
            textValue={noText}
            fontSize={14}
            onClick={() => onConfirm(false)}
            disabled={isSubmitting}
          />
          <AppButton
            variant="contained"
            textValue={yesText}
            fontSize={14}
            onClick={() => onConfirm(true)}
            disabled={isSubmitting}
            endIcon={
              isSubmitting ? (
                <CircularProgress
                  size={16}
                  color="inherit"
                  sx={{ margin: '0px 3px' }}
                />
              ) : null
            }
          />
        </AppBox>
      </AppBox>
    </ModalWindow>
  )
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  description: {
    fontSize: 12,
    color: 'text.secondary',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
    marginTop: 10,
  },
} as const